/**
 * Em'z Blendz Quick Add to Cart
 * Handles AJAX add-to-cart for "Goes Well With" product pairings
 */

(function() {
  'use strict';

  // Initialize on DOM ready and after dynamic content loads
  function init() {
    document.querySelectorAll('[data-quick-add]').forEach(initQuickAdd);
  }

  function initQuickAdd(container) {
    // Skip if already initialized
    if (container.dataset.quickAddInit) return;
    container.dataset.quickAddInit = 'true';

    const btn = container.querySelector('[data-quick-add-btn]');
    const select = container.querySelector('[data-quick-add-select]');
    const textEl = container.querySelector('[data-quick-add-text]');
    const loadingEl = container.querySelector('[data-quick-add-loading]');
    const successEl = container.querySelector('[data-quick-add-success]');

    if (!btn) return;

    // Update variant ID when select changes
    if (select) {
      select.addEventListener('change', function() {
        const selectedOption = this.options[this.selectedIndex];
        btn.dataset.variantId = this.value;
        
        // Enable/disable button based on availability
        if (selectedOption.disabled) {
          btn.disabled = true;
          btn.classList.add('quick-add__btn--disabled');
        } else {
          btn.disabled = false;
          btn.classList.remove('quick-add__btn--disabled');
        }
      });
    }

    // Handle add to cart click
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      
      if (btn.disabled) return;

      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      // Show loading state
      if (textEl) textEl.style.display = 'none';
      if (loadingEl) loadingEl.style.display = 'inline-flex';
      btn.disabled = true;

      // Add to cart via AJAX
      addToCart(variantId, 1)
        .then(function(response) {
          // Show success state
          if (loadingEl) loadingEl.style.display = 'none';
          if (successEl) successEl.style.display = 'inline-flex';
          btn.classList.add('quick-add__btn--success');

          // Update cart count in header
          updateCartCount();

          // Open cart drawer if theme supports it
          openCartDrawer();

          // Reset button after delay
          setTimeout(function() {
            if (successEl) successEl.style.display = 'none';
            if (textEl) textEl.style.display = 'inline-flex';
            btn.classList.remove('quick-add__btn--success');
            btn.disabled = false;
          }, 2000);
        })
        .catch(function(error) {
          console.error('Quick add error:', error);
          
          // Reset to normal state
          if (loadingEl) loadingEl.style.display = 'none';
          if (textEl) textEl.style.display = 'inline-flex';
          btn.disabled = false;

          // Show error message
          alert(error.message || 'Could not add to cart. Please try again.');
        });
    });
  }

  /**
   * Add item to cart via Shopify AJAX API
   */
  function addToCart(variantId, quantity) {
    return fetch(window.theme?.routes?.cartAdd || '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    })
    .then(function(response) {
      return response.json().then(function(data) {
        if (!response.ok) {
          throw new Error(data.message || data.description || 'Add to cart failed');
        }
        return data;
      });
    });
  }

  /**
   * Update cart count in header
   */
  function updateCartCount() {
    fetch(window.theme?.routes?.cart || '/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
    .then(function(response) { return response.json(); })
    .then(function(cart) {
      // Update header cart count (Impulse theme specific)
      const cartCounts = document.querySelectorAll('.cart-link__count, [data-cart-count]');
      cartCounts.forEach(function(el) {
        el.textContent = cart.item_count;
        // Show/hide based on count
        if (cart.item_count > 0) {
          el.classList.remove('hide');
        }
      });

      // Trigger theme's cart update event if available
      document.dispatchEvent(new CustomEvent('cart:updated', { 
        detail: { cart: cart } 
      }));
    })
    .catch(function(error) {
      console.error('Error updating cart count:', error);
    });
  }

  /**
   * Open cart drawer if theme supports it
   */
  function openCartDrawer() {
    // Check theme cart type setting
    const cartType = window.theme?.settings?.cartType;
    
    if (cartType === 'drawer') {
      // Impulse theme cart drawer
      const cartDrawer = document.querySelector('[data-cart-drawer]');
      if (cartDrawer) {
        // Trigger theme's cart drawer open
        document.dispatchEvent(new CustomEvent('cart:open'));
        
        // Fallback: try clicking the cart icon
        const cartIcon = document.querySelector('.cart-link, [data-cart-trigger]');
        if (cartIcon) {
          cartIcon.click();
        }
      }
    }
    // If cart type is 'page', we don't auto-navigate - the "Added!" feedback is enough
  }

  // Initialize on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize when recommendations load (they're loaded async)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            // Check if new node contains quick-add elements
            const quickAdds = node.querySelectorAll ? node.querySelectorAll('[data-quick-add]') : [];
            quickAdds.forEach(initQuickAdd);
            
            // Also check if the node itself is a quick-add
            if (node.matches && node.matches('[data-quick-add]')) {
              initQuickAdd(node);
            }
          }
        });
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

})();
